$shm_ba_file_picker $mol_pick
	app_id \
	file? null
	files? /File
	file_uri? \
	local_file_key? \
	pb_files_collection \user_files
	pb_files_field \file
	remote_files /
	remote_files_forced false
	trigger_content /
		<= File_trigger_icon $mol_icon_file
		<= File_title $mol_view
			sub /
				<= file_title \CSV
		<= File_trigger_more $mol_icon_dots_vertical
	bubble_content /
		<= Body $mol_list
			rows <= rows /
	Section* $mol_list
		rows <= section_rows* /
	Section_title* $mol_view
		sub /
			<= section_title* \
	File_open $shm_button_open
		title \Файл
		accept \.csv,.parquet,.duckdb,.db,text/csv,application/vnd.apache.parquet,application/octet-stream
		multiple false
		files? <=> files?
	Local_files $mol_list
		rows <= local_file_rows /
	Local_file* $mol_view
		sub /
			<= Local_file_pick* $shm_ba_file_picker_file_button
				title <= local_file_title* \
				current <= local_file_current* false
				click? <=> local_file_pick*? null
			<= Local_file_delete* $mol_button_minor
				hint \Удалить
				click? <=> local_file_delete*? null
				sub /
					<= Local_file_delete_icon* $mol_icon_close
	Remote_files $mol_list
		rows <= remote_file_rows /
	Remote_file* $shm_ba_file_picker_file_button
		title <= remote_file_title* \
		current <= remote_file_current* false
		click? <=> remote_file_pick*? null
	File_uri $mol_string
		hint \URI файла
		value? <=> file_uri? \

$shm_ba_file_picker_file_button $mol_button_minor
	current false
	attr *
		^
		shm_ba_file_picker_file_current <= current
	sub /
		<= File_icon $mol_icon_file
		<= Title $mol_view
			sub /
				<= title
	event *
		^
		click? <=> click? null
